<h1 class="-default-layout">{{card.title | translate}}</h1>
<div class="cockpit-view">
    <div class="table-wrapper">
        <h4>{{'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.drchschnittswerteErklärungsmerkmale' | translate}}</h4>

        <app-chart-download-button (buttonClick)="exportTable()">
          <h5>{{ 'sprint9.cockpit.card.all.tabelle' | translate }}</h5>
        </app-chart-download-button>
        <table>
            <tr>
                <td class="no-border"></td>
                <th scope="col" class="header centered bold border-bold-left">{{ 'i18n.common.maenner' | translate }} </th>
                <th scope="col" class="header centered bold">{{ 'i18n.common.frauen' | translate }} </th>
                <th scope="col" class="header centered bold border-bold-right">{{ 'm2.sprint3.personalmerkmale.differenz' | translate }} </th>
            </tr>

            <tr>
                <td class="header centered bold border-bold-left border-bold-right border-bold-left border-bold-right">
                    &nbsp;
                </td>
                <td class="centered"><small>(N = {{ personenStellenbezogeneMerkmale.anzahlMaenner | numberFormat: crtLocale  }})</small></td>
                <td class="centered"><small>(N = {{ personenStellenbezogeneMerkmale.anzahlFrauen | numberFormat: crtLocale  }})</small></td>
                <td class="border-bold-right centered"><small>&nbsp;</small></td>
            </tr>
            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.alterInJahren' | translate }}
                </th>
                <td >{{ personenStellenbezogeneMerkmale.alterMaenner | number:'1.1'}}</td>
                <td >{{ personenStellenbezogeneMerkmale.alterFrauen | number:'1.1'}}</td>
                <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.differenzAbsolutAlter | number:'1.1'}}</td>
            </tr>
            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.dienstjahre' | translate }}
                </th>
                <td >{{ personenStellenbezogeneMerkmale.dienstjahreMaenner | number:'1.1'}}</td>
                <td >{{ personenStellenbezogeneMerkmale.dienstjahreFrauen | number:'1.1'}}</td>
                <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.differenzAbsolutDienstjahre | number:'1.1'}}</td>
            </tr>
            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right border-bold-top">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.anforderungenAusbildung' | translate }}
                </th>
                <td class="border-bold-top">{{ personenStellenbezogeneMerkmale.anforderungAusbildungMaenner | number:'1.1'}}</td>
                <td class="border-bold-top">{{ personenStellenbezogeneMerkmale.anforderungAusbildungFrauen | number:'1.1'}}</td>
                <td class="border-bold-right border-bold-top">{{ personenStellenbezogeneMerkmale.differenzAbsolutAusbildung | number:'1.1'}}</td>
            </tr>
            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.anforderungenAutonomie' | translate }}
                </th>
                <td >{{ personenStellenbezogeneMerkmale.anforderungAutonomieMaenner | number:'1.1'}}</td>
                <td >{{ personenStellenbezogeneMerkmale.anforderungAutonomieFrauen | number:'1.1'}}</td>
                <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.differenzAbsolutAutonomie | number:'1.1'}}</td>
            </tr>
            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.anforderungenSpezifischesFachMethodenwissen' | translate }}
                </th>
                <td >{{ personenStellenbezogeneMerkmale.anforderungWissenMaenner | number:'1.1'}}</td>
                <td >{{ personenStellenbezogeneMerkmale.anforderungWissenFrauen | number:'1.1'}}</td>
                <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.differenzAbsolutWissen | number:'1.1'}}</td>
            </tr>

            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.verantwortungsbezogeneAnforderungenBelastungen' | translate }}
                </th>
                <td >{{ personenStellenbezogeneMerkmale.anforderungVerantwortungMaenner | number:'1.1'}}</td>
                <td >{{ personenStellenbezogeneMerkmale.anforderungVerantwortungFrauen | number:'1.1'}}</td>
                <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.differenzAbsolutVerantwortung | number:'1.1'}}</td>
            </tr>
            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.psychischeSozialeAnforderungenBelastungen' | translate }}
                </th>
                <td >{{ personenStellenbezogeneMerkmale.anforderungPsychischMaenner | number:'1.1'}}</td>
                <td >{{ personenStellenbezogeneMerkmale.anforderungPsychischFrauen | number:'1.1'}}</td>
                <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.differenzAbsolutPsychisch | number:'1.1'}}</td>
            </tr>
            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.koerperlicheAnforderungenBelastungen' | translate }}
                </th>
                <td >{{ personenStellenbezogeneMerkmale.anforderungKoerperlichMaenner | number:'1.1'}}</td>
                <td >{{ personenStellenbezogeneMerkmale.anforderungKoerperlichFrauen | number:'1.1'}}</td>
                <td class="border-bold-right">{{ personenStellenbezogeneMerkmale.differenzAbsolutKoerperlich | number:'1.1'}}</td>
            </tr>
            <tr class="content">
                <th scope="row" class="border-bold-left border-bold-right border-bold-top">
                    {{'m2.sprint3.cockpit.card.chart.personenStellenbezogeneMerkmale.funktionswertMminMax' | translate }}
                </th>
                <td class="border-bold-top">{{ personenStellenbezogeneMerkmale.funktionswertMaenner | number:'1.1'}}</td>
                <td class="border-bold-top">{{ personenStellenbezogeneMerkmale.funktionswertFrauen | number:'1.1'}}</td>
                <td class="border-bold-right border-bold-top">{{ personenStellenbezogeneMerkmale.differenzAbsolutFunktionswert | number:'1.1'}}</td>
            </tr>


            <tr class="hint" style="padding-top: 10px;">
                <td class="hint" colspan="4"style="padding-bottom: 50px;">{{'m2.sprint10.cockpit.card.hinveise-grundgesamtheit-gueltig' | translate}}</td>
            </tr>
        </table>
    </div>
</div>



